import script from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistory.vue?vue&type=style&index=0&id=48bc3ff6&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bc3ff6"]])

export default __exports__